<footer id="system-footer">
  <p>&copy; Cushman & Wakefield {{ currentYear }}. All Rights Reserved.</p>
  <div class="footer-links">
    <a class="" (click)="onClickAbout()">About</a>
  </div>
</footer>

<app-about-ctool #aboutRef></app-about-ctool>
